import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CRS, icon } from 'leaflet'
import { Map, ImageOverlay, Marker } from 'react-leaflet'
import {
  ZOOM_LEVELS,
  DEFAULT_PLAN_ZOOM_LEVEL,
  USER_PERMISSIONS,
} from '../constants'
import { hasPermission } from '../utils/hasPermission'
import { isActionableAlert, isAlertingType } from '../utils/helpers'

import podAlert from '../assets/floor-plan/pod-action-alert.svg'
import podInfoAlert from '../assets/floor-plan/pod-info-alert.svg'
import podUnassigned from '../assets/floor-plan/pod-unassigned.svg'
import podOffline from '../assets/floor-plan/pod-offline.svg'
import podOnline from '../assets/floor-plan/pod-online.svg'

import flowOnline from '../assets/floor-plan/flow-monitor-online.svg'
import flowOffline from '../assets/floor-plan/flow-monitor-offline.svg'
import flowAlert from '../assets/floor-plan/flow-monitor-action-alert.svg'
import flowInfoAlert from '../assets/floor-plan/flow-monitor-info-alert.svg'

// import leakPodOnline from '../assets/floor-plan/leak-pod.svg'
// import leakPodOffline from '../assets/floor-plan/leak-pod-offline.svg'
// import leakPodInfoAlert from '../assets/floor-plan/leak-pod-info-alert.svg'
// import leakPodAlert from '../assets/floor-plan/leak-pod-action-alert.svg'

class TinyFloorPlan extends Component {
  static propTypes = {
    floor: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  render() {
    const {
      floor: {
        planFileName,
        planZoomLevel = DEFAULT_PLAN_ZOOM_LEVEL,
        floorplanHeight = 0,
        floorplanWidth = 0,
      },
      location: {
        id,
        podPillarId,
        flowMonitorPillarId,
        activeAlerts,
        coordinates,
        alertActive,
        alertType,
        threshold,
      },
    } = this.props

    const bounds = [
      [0, 0],
      [floorplanHeight, floorplanWidth],
    ]
    let iconUrl =
      flowMonitorPillarId && hasPermission(USER_PERMISSIONS.VIEW_FLOW_MONITOR)
        ? flowOnline
        : podPillarId
        ? podOnline
        : podUnassigned

    if (alertActive) {
      if (isAlertingType(alertType)) {
        // device alerts are always actionable
        const isActionable = activeAlerts
          ? activeAlerts.some(isActionableAlert)
          : isActionableAlert({
              alertType,
              thresholdAlertType: threshold.thresholdAlertType,
            })

        iconUrl =
          flowMonitorPillarId &&
          hasPermission(USER_PERMISSIONS.VIEW_FLOW_MONITOR) &&
          isActionable
            ? flowAlert
            : flowMonitorPillarId &&
              hasPermission(USER_PERMISSIONS.VIEW_FLOW_MONITOR)
            ? flowInfoAlert
            : isActionable
            ? podAlert
            : podInfoAlert
      } else {
        iconUrl =
          flowMonitorPillarId &&
          hasPermission(USER_PERMISSIONS.VIEW_FLOW_MONITOR)
            ? flowOffline
            : podOffline
      }
    }

    const podIcon = icon({
      iconUrl,
      iconSize: [32, 32],
      iconAnchor: [15, 15],
      popupAnchor: [0, -15],
    })

    return (
      <div className="TinyFloorPlan mb3">
        <Map
          crs={CRS.Simple}
          maxBounds={bounds}
          zoom={planZoomLevel}
          center={coordinates}
          minZoom={ZOOM_LEVELS.MIN}
          maxZoom={ZOOM_LEVELS.MAX}
          className="ba b--gray br2 vh-25 black-80 lh-copy bg-moon-gray"
          attributionControl={false}
          zoomControl={false}
          doubleClickZoom={false}
        >
          <ImageOverlay url={planFileName} bounds={bounds} />
          <Marker position={coordinates} key={id} icon={podIcon} />
        </Map>
      </div>
    )
  }
}

export default TinyFloorPlan
